const AD_ACTION_JUMP_TO_CATEGORY = 'food_menu';
const AD_ACTION_JUMP_TO_FOOD_DETAIL = 'food_detail';

export { AD_ACTION_JUMP_TO_CATEGORY, AD_ACTION_JUMP_TO_FOOD_DETAIL };
